import './blackhaus/style';
import FormStructure from './blackhaus/form_structure';

export default FormStructure;